<ul style="list-style: none;" *ngIf="topic">
    <li *ngFor="let subtopic of topic.subtopics;">

            <span *ngIf ="(subtopic.is_open || subscription.is_premium)">
              <span *ngIf="subtopic.hasTemplates">

                 <input  *ngIf="subtopic.isSelected" type="checkbox" name="subtopic" value="{{subtopic.id}}" checked  (change)="updateQuizAreaItem(subtopic.id)"/>
                 <input  *ngIf="!subtopic.isSelected" type="checkbox" name="subtopic" value="{{subtopic.id}}" (change)="updateQuizAreaItem(subtopic.id)"/>
              </span>
              <i *ngIf="!subtopic.hasTemplates" class="fa fa-square  text-secondary"></i>

              <span> {{subtopic.name}}</span>
            </span>
            <span *ngIf ="!(subtopic.is_open ||subscription.is_premium)" >
            <i class="fa fa-square text-primary"></i> <span class="text-warning"> (premium)</span> {{subtopic.name}}
            </span>

    </li>

</ul>
